<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="11" height="18" viewBox="0 0 11 18" fill="none">
    <path d="M10.0732 1.16901L2 8.75781L9.5888 16.831" stroke="#285261" stroke-width="2"/>
    </svg>
</template>

<script lang="ts" setup></script>